import React, { useState } from "react";
import styled from "styled-components";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import appConfig from "../../../../app-config";
import { PICKUP, DELIVERY, DROPOFF } from "../../OrderSetting/orderSettingTypes";

const ChildLocationName = styled.div`
  display: flex;
  font-size: 40px;
  font-weight: 600;
  margin: auto;
  margin-left: 15px;
  padding-top: 30px;
  height: 100%;
`;

const Logo = styled.img`
  width: ${(props) => props.theme.logoWidth};
  cursor: pointer;
  margin-top: 5px;
  @media (max-width: 1200px) {
    margin-top: ${(props) => props.theme.logoMobileMargin};
  }
`;

function MenuSearch(props) {
  const { orderSettingReducer, searchProduct } = props;
  const {
    interPickUpDetails,
    interDeliveryDetails,
    interDropOffDetails,
    interOrderType,
  } = orderSettingReducer;

  const location =
    interOrderType === PICKUP && interPickUpDetails
      ? interPickUpDetails
      : interOrderType === DELIVERY && interDeliveryDetails && interDeliveryDetails.deliveryBusiness
      ? interDeliveryDetails.deliveryBusiness
      : interOrderType === DROPOFF && interDropOffDetails
      ? interDropOffDetails
      : null;

  const [search, setSearch] = useState("");

  const handleProductSearch = (ev) => {
    setSearch(ev.target.value);
    searchProduct(ev.target.value);
  };

  return location ? (
    <div
      style={{
        marginTop: "5px",
        marginLeft: "auto",
        margin: "0 5%",
      }}
    >
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div>
          <Logo src={location ? location.image_url : null} height="120px" />
        </div>
        <ChildLocationName>{location ? location.name : null}</ChildLocationName>
      </div>
      {false && (
        <div>
          <TextField
            style={{ borderRadius: 0, width: "100%", marginBottom: "10px" }}
            variant="outlined"
            size="small"
            value={search}
            onChange={(ev) => handleProductSearch(ev)}
            placeholder={`Search ${location ? location.name : null}`}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <i className="fas fa-search" />
                </InputAdornment>
              ),
            }}
          />
        </div>
      )}
    </div>
  ) : null;
}

export default MenuSearch;
